<template>
  <ul class="gallery no-bullet">
    <li class="js-newpage"
      v-for="episode in episodes"
      :key="episode.id"
    >
      <a class="has-icon icon-lb" v-if="currentUser && currentUser.listen_progresses && currentUser.listen_progresses[episode.id.toString()]" href=""
        @click.prevent="navigatorPush('Episode', { id: episode.id, title: episode.title })"
      >
        <img-with-placeholder :src="constants.phImg240x240" :data-src="sizeImg(episode.image_base_url, 240, 240)" :alt="episode.image.alt_text" v-if="episode.image" />
        <img-with-placeholder :src="constants.phImg240x240" :data-src="sizeImg(episode.channel.image_base_url, 240, 240)" :alt="episode.channel.image.alt_text" v-else />
        <span class="play icon icon-md">
          <icon-play />
        </span>
        <div class="progress-bar-2"><span v-bind:style="{ width: (episode.duration ? 100*currentUser.listen_progresses[episode.id.toString()]/episode.duration : 50) + '%' }"></span></div>
      </a>
      <a class="has-icon icon-lb" v-else href=""
        @click.prevent="navigatorPush('Episode', { id: episode.id, title: episode.title })"
      >
        <img-with-placeholder class="round-sm" :src="constants.phImg240x240" :data-src="sizeImg(episode.image_base_url, 240, 240)" :alt="episode.image.alt_text" v-if="episode.image" />
        <img-with-placeholder class="round-sm" :src="constants.phImg240x240" :data-src="sizeImg(episode.channel.image_base_url, 240, 240)" :alt="episode.channel.image.alt_text" v-else />
        <span class="play icon icon-md">
          <icon-play />
        </span>
      </a>
      <div class="txt">
        <h3 class="h3"><a href=""
          @click.prevent="navigatorPush('Episode', { id: episode.id, title: episode.title })"
        >{{ episode.title }}</a></h3>
        <div class="quiet small">
          <span class="duration" v-if="currentUser && currentUser.listen_progresses && currentUser.listen_progresses[episode.id.toString()]">
            {{ $t(`episode.duration_${episode.duration ? "left" : "listened"}`, { duration: $options.filters.secondsToDuration(Math.abs(episode.duration - currentUser.listen_progresses[episode.id.toString()])) }) }}
          </span>
          <span class="duration" v-else>{{ episode.duration | secondsToDuration }}</span>
        </div>
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  props: ['episodes'],
};
</script>
